import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mdc-slider mdc-slider--discrete" }
const _hoisted_2 = ["min", "max", "step", "name", "aria-label"]
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"mdc-slider__track\"><div class=\"mdc-slider__track--inactive\"></div><div class=\"mdc-slider__track--active\"><div class=\"mdc-slider__track--active_fill\"></div></div></div><div class=\"mdc-slider__thumb\"><div class=\"mdc-slider__value-indicator-container\" aria-hidden=\"true\"><div class=\"mdc-slider__value-indicator\"><span class=\"mdc-slider__value-indicator-text\">50</span></div></div><div class=\"mdc-slider__thumb-knob\"></div></div>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      class: "mdc-slider__input",
      type: "range",
      min: _ctx.min,
      max: _ctx.max,
      step: _ctx.step,
      name: _ctx.name,
      "aria-label": _ctx.label
    }, null, 8, _hoisted_2),
    _hoisted_3
  ]))
}